import { createFileRoute } from '@tanstack/react-router';
import { CheckoutErrorPage } from '@/modules/auth/pages/CheckoutErrorPage';

export const Route = createFileRoute('/checkout/error')({
  component: CheckoutErrorPage,
});
